package com.devi3east.bashbuddy.features.common.util

actual fun log(msg: String) {
    console.log("ModernCalendarPicker: $msg")
}